import { useState } from "react";
import { useDispatch } from "react-redux";
import { errorActions } from "../../../actions";
import { RequestState } from "../../../constants/request-state";
import { user } from "../../../user";
import { EvalTrialForm } from "../../../types/eval/EvalTrialForm";
import { billingService } from "../../../services";

export const useRequestEvalTrial = () => {
    const [requestState, setRequestState] = useState(RequestState.none);
    const dispatch = useDispatch();
    const requestEvalTrial = async (evalValues: EvalTrialForm) => {
        try {
            setRequestState(RequestState.request);
            const evalTrialEnd = await billingService.setEvalTrial(evalValues);

            if (evalTrialEnd) {
                user.setEvalTrial(new Date(evalTrialEnd));
            }

            setRequestState(RequestState.success);
        } catch (e) {
            dispatch(errorActions.unexpectedError(e));
            setRequestState(RequestState.failure);
        }
    };

    return { requestEvalTrial, requestState };
};
